<template>
    <div>
        <router-view></router-view>
    </div>
</template>

<script>
import request from "@/utils/request";
import useCache from "@/utils/user";
import { user } from "@/store/index";
import { mapActions } from "pinia";
require("@/style/common.css")

export default {
    props: {
        code: {
            type: String,
            default: "",
        },
        state: {
            type: String,
            default: "",
        }
    },
    data() {
        return {
            APPID: "wx30c19544fb01dee9",
            domain: "https://www.szszqrsy.com",
        }
    },
    created() {
        var slef = this;
        if (useCache.isLogin()) {
            request.get("/User/AccountMng/GetUserInfo").then((res) => {
                // console.log(res);
                slef.setUserInfo(res.data.data);
                useCache.cacheUserData(res.data.data);
            });
        } else {
            slef.$router.replace({
                path: '/credit/login',
                query: { source: 'credit' }
            })
        }
    },
    methods: {
        ...mapActions(user, ["setUserInfo"]),
    }
}
</script>

<style lang="less"></style>